import {
  AuthorityAuthor,
  AuthorityAuthorFromJSON,
  AuthorityCompleteWorks,
  AuthorityCompleteWorksFromJSON,
  AuthorityPublisher,
  AuthorityPublisherFromJSON,
  AuthoritySeries,
  AuthoritySeriesFromJSON,
  AuthoritySubject,
  AuthoritySubjectFromJSON,
  BibliographyAloneSearchRequest,
  BibliographyAloneSearchTooliRequest,
  BibliographyAloneSearchTooliRequestToJSON,
  BibliographyAuthorityAuthorSearchRequest,
  BibliographyAuthorityAuthorSearchRequestToJSON,
  BibliographyAuthorityCompleteWorksSearchRequest,
  BibliographyAuthorityCompleteWorksSearchRequestToJSON,
  BibliographyAuthorityContentAuthorSearchRequest,
  BibliographyAuthorityContentAuthorSearchRequestToJSON,
  BibliographyAuthorityPublisherSearchRequest,
  BibliographyAuthorityPublisherSearchRequestToJSON,
  BibliographyAuthoritySeriesSearchRequest,
  BibliographyAuthoritySeriesSearchRequestToJSON,
  BibliographyAuthoritySubjectSearchRequest,
  BibliographyAuthoritySubjectSearchRequestToJSON,
  BibliographyContentSearchRequest,
  BibliographyContentSearchRequestToJSON,
  BibliographyContentSearchTooliRequest,
  BibliographyContentSearchTooliRequestToJSON,
  BibliographyFreeSearchRequest,
  BibliographyIsbn,
  BibliographyIsbnFromJSON,
  BibliographyLendCount,
  BibliographyLendCountFromJSON,
  BibliographyMarc,
  BibliographyMarcFromJSON,
  BibliographySearchHistory,
  BibliographySearchHistoryFromJSON,
  BibliographySearchListDetail,
  BibliographySearchListDetailFromJSON,
  BibliographySearchListDetailRequest,
  BibliographySearchListDetailRequestToJSON,
  BibliographySearchRequest,
  BibliographySearchResult,
  BibliographySearchResultAuthorityItem,
  BibliographySearchResultAuthorityItemFromJSON,
  BibliographySearchResultContentItem,
  BibliographySearchResultContentItemFromJSON,
  BibliographySearchResultFromJSON,
  BibliographySearchTooliRequest,
  BibliographySearchTooliRequestToJSON,
  HTTPQuery,
  IntegrateBibliographyRequest,
  IntegrateBibliographyRequestToJSON,
  NewArrivalMagazine,
  NewArrivalMagazineFromJSON,
  RecombinantCollectionsRequest,
  RecombinantCollectionsRequestToJSON,
  SearchBibliographyIsbnRequest,
  SearchBibliographyIsbnRequestToJSON,
  SearchBibliographyMarcRequest,
  SearchBibliographyMarcRequestToJSON,
  SearchBibliographyNewArrivalMagazineRequest,
  SearchBibliographyNewArrivalMagazineRequestToJSON,
  UpdateBibliographyNewArrivalMagazineRequest,
  UpdateBibliographyNewArrivalMagazineRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class BibliographyApi extends runtime.BaseAPI {
  async getBibliographies(
    request: BibliographySearchRequest,
    signal?: AbortSignal
  ): Promise<BibliographySearchResult> {
    const bodyParameters: runtime.HTTPBody = request

    const response = await this.requestPost(
      `/bibliographies/search`,
      bodyParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BibliographySearchResultFromJSON(jsonValue)
    ).value()
  }

  async getAloneBibliographies(
    request: BibliographyAloneSearchRequest,
    signal?: AbortSignal
  ): Promise<BibliographySearchResult> {
    const bodyParameters: runtime.HTTPBody = request

    const response = await this.requestPost(
      `/bibliographies/search-alone`,
      bodyParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BibliographySearchResultFromJSON(jsonValue)
    ).value()
  }

  async getFreeBibliographies(
    request: BibliographyFreeSearchRequest,
    signal?: AbortSignal
  ): Promise<BibliographySearchResult> {
    const bodyParameters: runtime.HTTPBody = request

    const response = await this.requestPost(
      '/bibliographies/search-free-word',
      bodyParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BibliographySearchResultFromJSON(jsonValue)
    ).value()
  }

  async getBibliographySearchListDetail(
    request: BibliographySearchListDetailRequest
  ): Promise<BibliographySearchListDetail[]> {
    const response = await this.requestPost(
      '/bibliographies/search-list',
      BibliographySearchListDetailRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(BibliographySearchListDetailFromJSON)
    ).value()
  }

  /**
   * 書誌典拠責任表示情報を取得する
   * 書誌典拠責任表示取得
   */
  async getBibliographyAuthorityAuthor(
    searchKey: string,
    signal?: AbortSignal
  ): Promise<AuthorityAuthor[]> {
    const queryParameters: runtime.HTTPQuery = { search_key: searchKey }
    const response = await this.requestGet(
      '/bibliographies/authority-author',
      queryParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(AuthorityAuthorFromJSON)
    ).value()
  }

  /**
   * 書誌典拠件名情報を取得する
   * 書誌典拠件名情報取得
   */
  async getBibliographyAuthoritySubject(
    searchKey: string,
    signal?: AbortSignal
  ): Promise<AuthoritySubject[]> {
    const queryParameters: runtime.HTTPQuery = { search_key: searchKey }
    const response = await this.requestGet(
      '/bibliographies/authority-subject',
      queryParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(AuthoritySubjectFromJSON)
    ).value()
  }

  /**
   * 書誌典拠責任表示情報を取得する
   * 書誌典拠責任表示取得
   */
  async getBibliographiesAuthoritySeries(
    searchKey: string,
    signal?: AbortSignal
  ): Promise<AuthoritySeries[]> {
    const queryParameters: runtime.HTTPQuery = { search_key: searchKey }
    const response = await this.requestGet(
      '/bibliographies/authority-series',
      queryParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(AuthoritySeriesFromJSON)
    ).value()
  }

  /**
   * 書誌典拠全集情報を取得する
   * 書誌典拠全集表示取得
   */
  async getBibliographyAuthorityCompleteWorks(
    searchKey: string,
    signal?: AbortSignal
  ): Promise<AuthorityCompleteWorks[]> {
    const queryParameters: runtime.HTTPQuery = { search_key: searchKey }
    const response = await this.requestGet(
      '/bibliographies/authority-complete-works',
      queryParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(AuthorityCompleteWorksFromJSON)
    ).value()
  }

  /**
   * 書誌典拠出版者を取得する
   * 書誌典拠出版者取得
   */
  async getBibliographyAuthorityPublisher(
    searchKey: string,
    signal?: AbortSignal
  ): Promise<AuthorityPublisher[]> {
    const queryParameters: runtime.HTTPQuery = { search_key: searchKey }
    const response = await this.requestGet(
      '/bibliographies/authority-publisher',
      queryParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(AuthorityPublisherFromJSON)
    ).value()
  }

  /**
   * 書誌検索履歴一覧を取得する
   * 書誌検索履歴一覧取得
   */
  async getBibliographySearchHistories(): Promise<BibliographySearchHistory[]> {
    const response = await this.requestGet('/bibliographies/search-histories')

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(BibliographySearchHistoryFromJSON)
    ).value()
  }

  /**
   * 書誌検索履歴を削除する
   * 書誌検索履歴削除
   */
  async deleteBibliographySearchHistories(): Promise<runtime.VoidApiResponse> {
    const response = await this.requestDelete(
      '/bibliographies/search-histories'
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 典拠責任表示を検索する
   * 典拠責任表示原作
   */
  async searchBibliographyAuthorityAuthor(
    request: BibliographyAuthorityAuthorSearchRequest,
    signal?: AbortSignal
  ): Promise<BibliographySearchResultAuthorityItem[]> {
    const bodyParameters: runtime.HTTPBody = BibliographyAuthorityAuthorSearchRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies/search-authority-author',
      bodyParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(BibliographySearchResultAuthorityItemFromJSON)
    ).value()
  }

  /**
   * 典拠内容責任表示を検索する
   * 典拠内容責任表示検索
   */
  async searchBibliographyAuthorityContentAuthor(
    request: BibliographyAuthorityContentAuthorSearchRequest,
    signal?: AbortSignal
  ): Promise<BibliographySearchResultAuthorityItem[]> {
    const bodyParameters: runtime.HTTPBody = BibliographyAuthorityContentAuthorSearchRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies/search-authority-content-author',
      bodyParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(BibliographySearchResultAuthorityItemFromJSON)
    ).value()
  }

  /**
   * 典拠件名を検索する
   * 典拠件名検索
   */
  async searchBibliographyAuthoritySubject(
    request: BibliographyAuthoritySubjectSearchRequest,
    signal?: AbortSignal
  ): Promise<BibliographySearchResultAuthorityItem[]> {
    const bodyParameters: runtime.HTTPBody = BibliographyAuthoritySubjectSearchRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies/search-authority-subject',
      bodyParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(BibliographySearchResultAuthorityItemFromJSON)
    ).value()
  }

  /**
   * 典拠全集を検索する
   * 典拠全集検索
   */
  async searchBibliographyAuthorityCompleteWorks(
    request: BibliographyAuthorityCompleteWorksSearchRequest,
    signal?: AbortSignal
  ): Promise<BibliographySearchResultAuthorityItem[]> {
    const bodyParameters: runtime.HTTPBody = BibliographyAuthorityCompleteWorksSearchRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies/search-authority-complete-works',
      bodyParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(BibliographySearchResultAuthorityItemFromJSON)
    ).value()
  }

  /**
   * 典拠シリーズを検索する
   * 典拠シリーズ検索
   */
  async searchBibliographyAuthoritySeries(
    request: BibliographyAuthoritySeriesSearchRequest,
    signal?: AbortSignal
  ): Promise<BibliographySearchResultAuthorityItem[]> {
    const bodyParameters: runtime.HTTPBody = BibliographyAuthoritySeriesSearchRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies/search-authority-series',
      bodyParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(BibliographySearchResultAuthorityItemFromJSON)
    ).value()
  }

  /**
   * 典拠出版者を検索する
   * 典拠出版者検索
   */
  async searchBibliographyAuthorityPublisher(
    request: BibliographyAuthorityPublisherSearchRequest,
    signal?: AbortSignal
  ): Promise<BibliographySearchResultAuthorityItem[]> {
    const bodyParameters: runtime.HTTPBody = BibliographyAuthorityPublisherSearchRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies/search-authority-publisher',
      bodyParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(BibliographySearchResultAuthorityItemFromJSON)
    ).value()
  }

  /**
   * 書誌内容を検索する
   * 書誌内容検索
   */
  async searchBibliographyContent(
    request: BibliographyContentSearchRequest,
    signal?: AbortSignal
  ): Promise<BibliographySearchResultContentItem[]> {
    const bodyParameters: runtime.HTTPBody = BibliographyContentSearchRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies/search-content',
      bodyParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map((value: any, index: number) => {
        return BibliographySearchResultContentItemFromJSON(value, index)
      })
    ).value()
  }

  /**
   * 貸出回数を取得する
   * 貸出回数取得
   */
  async getBibliographyLendCounts(
    bibliographyId: number
  ): Promise<BibliographyLendCount[]> {
    const response = await this.requestGet(
      `/bibliographies/${bibliographyId}/lend-count`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(BibliographyLendCountFromJSON)
    ).value()
  }

  /**
   * 書誌を統合する
   * 書誌統合
   */
  async integrateBibliography(
    request: IntegrateBibliographyRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = IntegrateBibliographyRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies/integrate',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 資料を組み替える
   * 資料組み換え
   */
  async recombinantCollections(
    request: RecombinantCollectionsRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = RecombinantCollectionsRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies/recombinant',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 書誌をMARC検索する
   * 書誌MARC検索
   */
  async searchBibliographyMarc(
    request: SearchBibliographyMarcRequest
  ): Promise<BibliographyMarc> {
    const queryParameters: runtime.HTTPQuery = SearchBibliographyMarcRequestToJSON(
      request
    )

    const response = await this.requestGet(
      '/bibliographies/search-marc',
      Object.fromEntries(
        Object.entries(queryParameters).filter(value => value[1] !== undefined)
      )
    )
    return new runtime.JSONApiResponse(response, jsonValue =>
      BibliographyMarcFromJSON(jsonValue)
    ).value()
  }

  /**
   * 書誌をISBN検索する
   * 書誌ISBN検索
   */
  async searchBibliographyIsbn(
    request: SearchBibliographyIsbnRequest
  ): Promise<BibliographyIsbn[]> {
    const queryParameters: runtime.HTTPQuery = SearchBibliographyIsbnRequestToJSON(
      request
    )

    const response = await this.requestGet(
      '/bibliographies/search-isbn',
      Object.fromEntries(
        Object.entries(queryParameters).filter(value => value[1] !== undefined)
      )
    )
    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(BibliographyIsbnFromJSON)
    ).value()
  }

  /**
   * 書誌をtooli基本検索する
   * 書誌tooli基本検索
   */
  async searchTooliBibliographies(
    request: BibliographySearchTooliRequest,
    signal?: AbortSignal
  ): Promise<BibliographySearchResult> {
    const bodyParameters: runtime.HTTPBody = BibliographySearchTooliRequestToJSON(
      request
    )

    const response = await this.requestPost(
      `/bibliographies/search-tooli`,
      bodyParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BibliographySearchResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 書誌をtooli単独検索する
   * 書誌tooli単独検索
   */
  async searchAloneTooliBibliographies(
    request: BibliographyAloneSearchTooliRequest,
    signal?: AbortSignal
  ): Promise<BibliographySearchResult> {
    const bodyParameters: runtime.HTTPBody = BibliographyAloneSearchTooliRequestToJSON(
      request
    )

    const response = await this.requestPost(
      `/bibliographies/search-alone-tooli`,
      bodyParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BibliographySearchResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 書誌をtooli内容検索する
   * 書誌tooli内容検索
   */
  async searchContentTooliBibliographies(
    request: BibliographyContentSearchTooliRequest,
    signal?: AbortSignal
  ): Promise<BibliographySearchResult> {
    const bodyParameters: runtime.HTTPBody = BibliographyContentSearchTooliRequestToJSON(
      request
    )

    const response = await this.requestPost(
      `/bibliographies/search-content-tooli`,
      bodyParameters,
      signal
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BibliographySearchResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 新着雑誌を検索する
   * 新着雑誌検索
   */
  async searchBibliographyNewArrivalMagazine(
    request: SearchBibliographyNewArrivalMagazineRequest
  ): Promise<NewArrivalMagazine[]> {
    const queryParameters: HTTPQuery = Object.fromEntries(
      Object.entries(
        SearchBibliographyNewArrivalMagazineRequestToJSON(request)
      ).filter(value => value[1] !== undefined)
    ) as HTTPQuery

    const response = await this.requestGet(
      '/bibliographies/new_arrival_magazine',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(NewArrivalMagazineFromJSON)
    ).value()
  }

  /**
   * 新着雑誌を更新する
   * 新着雑誌更新
   */
  async updateBibliographyNewArrivalMagazine(
    request: UpdateBibliographyNewArrivalMagazineRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateBibliographyNewArrivalMagazineRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies/new_arrival_magazine',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
